import React from 'react';
import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useAppLayoutStyles } from './AppLayout.styles';
import { Footer } from '@onboarding/shared';
import { OnboardingJourney } from '../OnboardingJourney';
import { PolicyPage } from '../PolicyPage';
import { PolicyViewer } from '../PolicyViewer';
import { withImpersonation } from '../../utils/impersonation';

export const AppLayout: React.FC = () => {
  const styles = useAppLayoutStyles();
  const { search } = useLocation();

  return (
    <main id="maincontent" className={styles.container}>
      <div className={styles.mainContent}>
        <div className={styles.contentWrapper}>
          <Routes>
            <Route path="/" element={<OnboardingJourney />} />
            <Route path="/policies" element={<PolicyPage />} />
            <Route path="/policies/:policyId" element={<PolicyViewer />} />
            <Route path="*" element={<Navigate to={withImpersonation('/', search)} replace />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </main>
  );
};
